module.exports = __webpack_public_path__ + "img/Sharing.7862e26d.svg";